import { render, staticRenderFns } from "./Abierto.vue?vue&type=template&id=67d60f5c&scoped=true&"
import script from "./Abierto.vue?vue&type=script&lang=js&"
export * from "./Abierto.vue?vue&type=script&lang=js&"
import style0 from "./Abierto.vue?vue&type=style&index=0&id=67d60f5c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "67d60f5c",
  null
  
)

export default component.exports